import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '../useApiMutation';
import { apiDelete, operationsClient } from '@/lib/api';
import { opsEstimateEndpoints } from '@/lib/api/endpoints';
import { estimateKeys } from '@/lib/queryKeys';

export function useHardDeleteEstimate() {
  const queryClient = useQueryClient();

  return useApiMutation<void, string>({
    mutationFn: (id) => apiDelete<void>(operationsClient, opsEstimateEndpoints.delete(id)),
    onSuccess: (_data, id) => {
      void queryClient.invalidateQueries({ queryKey: estimateKeys.lists() });
      queryClient.removeQueries({ queryKey: estimateKeys.detail(id) });
      toast.success('Estimate deleted');
    },
  });
}
